/**
 * Created by akrio on 2018/4/29.
 */
import app from "../../main";

/**
 * 确认取消弹出框
 */
export const ConfirmPlugin = {
  install(Vue) {
    const confirm = {
      async show(options = {}) {
        let title = options.title || "";
        let message = options.text || options;
        let cancelButtonText = options.cancelText || app.$t("common.cancel");
        let confirmButtonText = options.yesText || app.$t("common.yes");
        let showClose =
          options.showClose === undefined ? true : options.showClose;
        const promise = await app.$msgbox({
          title,
          message,
          showCancelButton: true,
          cancelButtonText,
          confirmButtonText,
          showClose,
          distinguishCancelAndClose: true,
        });
        return promise;
      },
    };
    Vue.mixin({
      created: function () {
        this.$confirm = confirm;
      },
    });
  },
};
/**
 * Alert 插件
 */
export const AlertPlugin = {
  install(Vue) {
    const alert = {
      async show(options = {}) {
        let message = options.text || options;
        let title = options.title || "";
        let confirmButtonText = options.yesText || app.$t("common.yes");
        const promise = await app.$msgbox({
          title,
          message,
          confirmButtonText,
        });
        return promise;
      },
    };
    Vue.mixin({
      created: function () {
        this.$alert = alert;
      },
    });
  },
};
